<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 10H3.686a3.913 3.913 0 0 1-2.494-.88A3.207 3.207 0 0 1 .014 6.955a3.1 3.1 0 0 1 .739-2.3 3.816 3.816 0 0 1 2.628-1.3A5.482 5.482 0 0 1 8.254.014a6.19 6.19 0 0 1 .361-.01 5.341 5.341 0 0 1 5.522 4.674 2.784 2.784 0 0 1 1.862 2.555 2.943 2.943 0 0 1-3.077 2.77H9V7.797a2.5 2.5 0 1 0-2 0v2.205Z" fill="currentColor"/><path d="M12 13.5a2 2 0 0 1 1-1.73V7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4.269a2 2 0 1 1-3 1.732Zm-12 0a2 2 0 0 1 1-1.731v-4.27a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4.27A2 2 0 1 1 0 13.5Z" opacity=".45" fill="currentColor"/><path d="M5.5 13.5A2.5 2.5 0 0 1 7 11.21V10h2v1.21a2.5 2.5 0 1 1-3.5 2.29Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering201',
});
</script>
